import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ccc8ed68"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "software-main" }
const _hoisted_2 = { class: "software-header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "software-header-region" }
const _hoisted_5 = { class: "software-header-title" }
const _hoisted_6 = { class: "software-header-text" }
const _hoisted_7 = { class: "software-content" }
const _hoisted_8 = { class: "software-content-main" }
const _hoisted_9 = { class: "software-content-titlebox" }
const _hoisted_10 = { class: "software-content-title" }
const _hoisted_11 = { class: "software-content-description" }
const _hoisted_12 = { class: "software-content-grid" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "software-item-img" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "software-item-text" }
const _hoisted_17 = { class: "software-item-title" }
const _hoisted_18 = { class: "software-item-description" }
const _hoisted_19 = { class: "software-item-description-text" }
const _hoisted_20 = { class: "software-content-titlebox" }
const _hoisted_21 = { class: "software-content-title" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "software-content-border" }, null, -1))
const _hoisted_23 = { class: "software-content-grid" }
const _hoisted_24 = { class: "software-foot" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "software-foot-main" }
const _hoisted_27 = { class: "software-foot-title" }
const _hoisted_28 = { class: "software-foot-description" }
const _hoisted_29 = { class: "software-foot-process" }
const _hoisted_30 = { class: "soft-process-cycle" }
const _hoisted_31 = { class: "soft-process-num" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "software-foot-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_informationEdit = _resolveComponent("informationEdit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "software-header-img",
        src: require('@/assets/img/software/software-sub-bg.png')
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.softwareText.subField1), 1),
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.softwareText.subField2), 1)
      ]),
      _createElementVNode("div", {
        class: "software-header-btn cursor hover",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showEdit = true))
      }, _toDisplayString(_ctx.btnName), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.softwareText.field1), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.softwareText.field3), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.softwareText.children, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              onClick: ($event: any) => (_ctx.gotoDetail(item)),
              key: item.id,
              class: "software-grid-item cursor"
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("img", {
                  src: item.btnImg
                }, null, 8, _hoisted_15)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(item.name), 1),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(item.description), 1)
                ])
              ])
            ], 8, _hoisted_13))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.softwareText.subField3), 1),
          _hoisted_22
        ]),
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.softwareText.subBtn, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "software-grid-item2"
            }, _toDisplayString(item.name), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _createElementVNode("img", {
        class: "software-foot-img",
        src: _ctx.softwareText.footImg
      }, null, 8, _hoisted_25),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.softwareText.footField1), 1),
        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.softwareText.footField2), 1),
        _createElementVNode("div", _hoisted_29, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.softwareText.processList, (process, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "software-process-item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, _toDisplayString(index+1), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass((index%2===0)?'software-process-detailbox-up':'software-process-detailbox-down')
              }, _toDisplayString(process), 3),
              (index !==_ctx.softwareText.processList.length-1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "soft-process-img",
                    src: require('@/assets/img/software/software-foot-process.png')
                  }, null, 8, _hoisted_32))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass((index%2===0)?'software-process-column-up':'software-process-column-down')
              }, null, 2)
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showEdit = true)),
            class: "software-foot-btn cursor hover-opacity-8"
          }, _toDisplayString(_ctx.btnName2), 1)
        ])
      ])
    ]),
    (_ctx.showEdit)
      ? (_openBlock(), _createBlock(_component_informationEdit, {
          key: 0,
          class: "information",
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showEdit=false))
        }))
      : _createCommentVNode("", true)
  ]))
}